function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 10,
  width: 2,
  height: 16,
  rx: 1,
  transform: "rotate(90 19 10)"
});
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref);
}
export default SvgMinus;